// features/exampleFeature/ui/ExampleModal.tsx
import React from 'react';
import { modalStore } from '../../../entities/modal/model/modal.store';
import styled from 'styled-components';

const Title = styled.h2`
  @apply text-xl font-bold mb-4;
`;

const Description = styled.p`
  @apply text-gray-600 mb-6;
`;

const Button = styled.button`
  @apply bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700;
`;

type ExampleModalProps = {
  id?: number;
  message?: string;
};

export const ExampleModal: React.FC<ExampleModalProps> = ({ id, message }) => {
  const handleClose = () => {
    modalStore.closeModal();
  };

  return (
    <div>
      <Title>Пример модального окна</Title>
      <Description>
        Это модальное окно. {message ? `Сообщение: ${message}` : 'Нет сообщения.'}
        {id !== undefined && <div className="mt-2 text-sm text-gray-500">ID: {id}</div>}
      </Description>
      <Button onClick={handleClose}>Закрыть</Button>
    </div>
  );
};
